let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lFsVz")).then(() => parcelRequire('fKvyc'));